/**
 * OCR client — runs the browser pipeline and calls CMS Laravel OCR API.
 */

import {
  extractDocumentFromFile,
  isOcrServiceConfigured,
  OCR_API_BASE,
} from "../services/ocr";

export const getDocScannerBaseUrl = () => OCR_API_BASE;
export const isDocScannerConfigured = isOcrServiceConfigured;

/**
 * @param {File} file
 * @param {{ signal?: AbortSignal, documentType?: string, onProgress?: Function }} [options]
 * @returns {Promise<{ success: true, result: object }>}
 */
export const fetchDocScannerExtraction = async (file, options = {}) => {
  if (!isOcrServiceConfigured()) {
    throw new Error("OCR service is not configured.");
  }

  if (options.signal?.aborted) {
    throw new DOMException("Aborted", "AbortError");
  }

  const abortPromise = options.signal
    ? new Promise((_, reject) => {
        options.signal.addEventListener(
          "abort",
          () => reject(new DOMException("Aborted", "AbortError")),
          { once: true },
        );
      })
    : null;

  const extractionPromise = extractDocumentFromFile(file, options.documentType, {
    onProgress: options.onProgress,
  });

  const result = abortPromise
    ? await Promise.race([extractionPromise, abortPromise])
    : await extractionPromise;

  return { success: true, result };
};
